window.UPLOADCARE_PUBLIC_KEY = '9f6a22c74e597c4a8482';
window.UPLOADCARE_LOCALE = 'de';

// Uploadcare-Script vorladen, aber Widget erst beim ersten Popup-Öffnen initialisieren
const ucScript = document.createElement('script');
ucScript.src = 'https://ucarecdn.com/libs/widget/3.x/uploadcare.full.min.js';
document.head.appendChild(ucScript);

document.addEventListener('DOMContentLoaded', function () {

  const overlay    = document.getElementById('quote-popup-overlay');
  const closeBtn   = document.getElementById('quote-popup-close');
  const form       = document.getElementById('quote-form');
  const successMsg = document.getElementById('quote-success');
  const errorMsg   = document.getElementById('quote-error');

  if (!overlay) return;

  // ── Uploadcare: erst initialisieren wenn Popup erstmals geöffnet ──
  let ucWidgetReady = false;

  function initUploadcare() {
    if (ucWidgetReady) return;
    if (typeof uploadcare === 'undefined') {
      // Script noch nicht geladen – kurz warten und nochmal versuchen
      setTimeout(initUploadcare, 300);
      return;
    }
    const widget = uploadcare.Widget('#quote-upload-widget');
    widget.onUploadComplete(function (fileInfo) {
      document.getElementById('quote-logo-url').value = fileInfo.cdnUrl;
    });
    ucWidgetReady = true;
  }

  // ── Popup öffnen ──────────────────────────────────────────────────
  // Wird vom Kalkulator-Block über window.openQuotePopup() aufgerufen
  window.openQuotePopup = function(data) {
    // Felder aus Kalkulator vorausfüllen
    if (data) {
      var productField = document.getElementById('quote-product');
      if (productField && data.product) productField.value = data.product;

      var veredlungField = document.getElementById('quote-veredlung');
      if (veredlungField && data.bezeichnung) veredlungField.value = data.bezeichnung;

      var quantityField = document.getElementById('quote-quantity');
      if (quantityField && data.menge) quantityField.value = data.menge;

      // Kalkulations-Summary als verstecktes Feld
      var summaryField = document.getElementById('quote-kalkulation-summary');
      if (!summaryField) {
        summaryField = document.createElement('input');
        summaryField.type = 'hidden';
        summaryField.id = 'quote-kalkulation-summary';
        form.appendChild(summaryField);
      }
      if (data.summary) summaryField.value = data.summary;
    }

    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // Uploadcare erst jetzt initialisieren (Popup ist sichtbar)
    initUploadcare();
  };

  // ── Popup schließen ───────────────────────────────────────────────
  function closePopup() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closePopup();
  });

  // ── Formular absenden ─────────────────────────────────────────────
  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const logoUrl = document.getElementById('quote-logo-url').value;
    if (!logoUrl) {
      alert('Bitte laden Sie Ihr Logo hoch.');
      return;
    }

    const kalkulationSummary = document.getElementById('quote-kalkulation-summary')?.value || '';

    const formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[email]', document.getElementById('quote-email').value);
    formData.append('contact[name]',  document.getElementById('quote-name').value);
    formData.append('contact[body]',
      `Angebotsanfrage von ${document.getElementById('quote-company').value}\n\n` +
      `Produkt: ${document.getElementById('quote-product').value}\n` +
      `Veredelung: ${document.getElementById('quote-veredlung').value}\n` +
      `Menge: ${document.getElementById('quote-quantity').value}\n` +
      (kalkulationSummary ? `\nKalkulation: ${kalkulationSummary}\n` : '') +
      `\nLogo-Datei: ${logoUrl}\n\n` +
      `Anmerkungen:\n${document.getElementById('quote-message').value}`
    );

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (response.ok) {
        form.style.display = 'none';
        successMsg.style.display = 'block';
        setTimeout(closePopup, 3000);
      } else {
        errorMsg.style.display = 'block';
      }
    } catch (err) {
      errorMsg.style.display = 'block';
    }
  });

});
